import { c as _c } from "react/compiler-runtime";
import { Toggle } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import usePlaybooksQueryParams from '../../../hooks/use-playbooks-query-params';
import DrawerFilter from './drawer-filter';
const Filters = () => {
  const $ = _c(22);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "table.filters"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("playbooks", t0);
  const queryParams = usePlaybooksQueryParams();
  const {
    filtersCount
  } = queryParams;
  let t1;
  if ($[1] !== queryParams) {
    t1 = checked => {
      queryParams.push({
        hideDisabled: checked
      });
    };
    $[1] = queryParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleToggleChange = t1;
  let t2;
  if ($[3] !== queryParams) {
    t2 = open => {
      queryParams.push({
        showFilters: open
      });
    };
    $[3] = queryParams;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleOpenChange = t2;
  let t3;
  if ($[5] !== queryParams) {
    t3 = kinds => {
      queryParams.push({
        kinds,
        showFilters: false
      });
    };
    $[5] = queryParams;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== filtersCount || $[8] !== handleOpenChange || $[9] !== queryParams.values.kinds || $[10] !== queryParams.values.showFilters || $[11] !== t3) {
    t4 = <div><DrawerFilter count={filtersCount} isOpen={queryParams.values.showFilters} onOpenChange={handleOpenChange} onSubmit={t3} defaultValues={queryParams.values.kinds} /></div>;
    $[7] = filtersCount;
    $[8] = handleOpenChange;
    $[9] = queryParams.values.kinds;
    $[10] = queryParams.values.showFilters;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = queryParams.values.hideDisabled;
  let t6;
  if ($[13] !== t) {
    t6 = t(_temp);
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== handleToggleChange || $[16] !== queryParams.values.hideDisabled || $[17] !== t6) {
    t7 = <div><Toggle checked={t5} label={t6} onChange={handleToggleChange} size="compact" /></div>;
    $[15] = handleToggleChange;
    $[16] = queryParams.values.hideDisabled;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t7) {
    t8 = <div className="flex flex-wrap gap-3 items-center justify-between w-full">{t4}{t7}</div>;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default Filters;
function _temp($) {
  return $.hideDisabled;
}